import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { UrlService } from '../../core/url.service';
import { daysRemaining } from '../../partner-trial';
import { TrialBannerService, TrialDetails } from '../trial-banner.service';

@Component({
  selector: 'app-trial-banner',
  templateUrl: './trial-banner.component.html',
  styleUrls: ['./trial-banner.component.scss'],
  standalone: false,
})
export class TrialBannerComponent implements OnInit {
  trialDetails$: Observable<TrialDetails>;
  remainingDays$: Observable<number>;
  dateFormat = DateFormat;
  isSuperAdminRoute$: Observable<boolean>;
  isAutomationsRoute$: Observable<boolean>;

  constructor(
    private trialBannerService: TrialBannerService,
    private router: Router,
    private readonly analyticsService: ProductAnalyticsService,
    private urlService: UrlService,
  ) {}

  ngOnInit(): void {
    this.isAutomationsRoute$ = this.urlService.isAutomationsRoute$;
    this.isSuperAdminRoute$ = this.urlService.isSuperAdminRoute$;
    this.trialDetails$ = this.trialBannerService.getTrialDetails$().pipe(
      catchError(() => {
        return of({ onTrial: false, isFree: false });
      }),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    this.remainingDays$ = this.trialDetails$.pipe(
      map((details) => {
        return daysRemaining(details.startDate, details.endDate);
      }),
    );
  }

  openSalesVideo(): void {
    this.analyticsService.trackEvent('watch-sales-video', 'trial-banner', 'click');
    const videoUrl = 'https://vendasta-1.wistia.com/medias/55ko816exp';
    window.open(videoUrl, '_blank');
  }

  learnMore(): void {
    this.analyticsService.trackEvent('learn-more', 'trial-banner', 'click');
    this.router.navigateByUrl('/upgrade-subscription-tier');
  }
}
